import './scss/whitedesign.scss';
import './components';
import './directives';
import AppBase from './base';

new AppBase({});



// WEBPACK FOOTER //
// ./index.js